// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"472":"424b289187625c19","9341":"854d4c78776604e4"}[chunkId] + ".js";
};